

exports.__esModule = true;
exports.$xoAddNationalIdPageComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-form-components/src/national-id-input/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-page-components/src/value-props/directive');

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddNationalIdPageComponent = exports.$xoAddNationalIdPageComponent = _squid.$Component.extend('$xoAddNationalIdPageComponent', {
    tag: 'xo-add-national-id-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, $state, $locale, $AddKYCModel, $CheckoutSessionModel, $NationalIdModel, $logger) {

        $scope.locale = $locale;
        $scope.user = {
            country: $locale.country,
            countryOfResidence: $locale.country
        };

        $scope.validate = function () {
            $scope.validated = true;
            return true;
        };

        $scope.onContinue = function () {
            $scope.nationalIdModel = $NationalIdModel.instance($rootScope.token);
            $scope.checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
            $scope.addKYC = new $AddKYCModel({
                token: $rootScope.token
            });

            $scope.KYCData = {
                nationalIdModel: $scope.nationalIdModel,
                user: $scope.user
            };

            $scope.addKYC.save({

                data: $scope.KYCData,

                success: function success() {
                    $state.go('checkout.review');
                },

                contingencies: {
                    DEFAULT: function DEFAULT(err, message) {
                        $logger.info('add_KYC_contingency', {
                            name: err,
                            message: message
                        });
                    }
                },
                validation: function validation(res) {}
            });
        };
    }
});

angular.value("$xoAddNationalIdPageComponent", $xoAddNationalIdPageComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-national-id/directive.js
// module id = ./pages/xo-add-national-id/directive.js
// module chunks = 1